module.exports = __webpack_public_path__ + "vr_portal_asset.jpg?9e5c8c4616d75cfe85bc1f462def519c";